// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../../index';

import { gql } from 'graphql-tag';
export const MetalFilterMetalFragmentDoc = gql`
    fragment metalFilterMetal on Metal {
  systemCode
  translation(locale: $locale) {
    name
  }
  karat
  color {
    systemCode
    translation(locale: $locale) {
      name
    }
  }
  element {
    systemCode
    translation(locale: $locale) {
      name
    }
  }
}
    `;
export const MetalFilterFragmentDoc = gql`
    fragment metalFilter on CatalogueFilterMetalItem {
  metal {
    ...metalFilterMetal
  }
  totalResults
}
    ${MetalFilterMetalFragmentDoc}`;